export default __webpack_public_path__ + "static/media/Group 30.596dc2ef.png";